var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 85,
    viewBox: "0 0 66 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_13350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 63.751H2V72.751H48V63.751Z",
    fill: "#3FCC3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 2.75098H2V10.751H48V2.75098Z",
    fill: "#3FCC3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.001 1.5H5.00098C3.06798 1.5 1.50098 3.067 1.50098 5V70C1.50098 71.933 3.06798 73.5 5.00098 73.5H45.001C46.934 73.5 48.501 71.933 48.501 70V5C48.501 3.067 46.934 1.5 45.001 1.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53809 12.184H47.5011",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53809 62.915H47.5011",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.913 42.227C16.913 38.291 11.185 39.539 11.185 37.299C11.185 36.387 11.841 35.955 12.721 35.987C13.681 36.003 14.273 36.579 14.321 37.315H16.785C16.641 35.299 15.073 34.131 12.785 34.131C10.481 34.131 8.84898 35.347 8.84898 37.363C8.83298 41.411 14.593 39.955 14.593 42.371C14.593 43.171 13.969 43.731 12.913 43.731C11.873 43.731 11.281 43.139 11.217 42.243H8.81698C8.84898 44.355 10.641 45.571 12.961 45.571C15.505 45.571 16.913 43.987 16.913 42.227ZM18.855 45.459H21.095V38.195L24.103 45.459H25.799L28.791 38.195V45.459H31.031V34.291H28.503L24.951 42.595L21.399 34.291H18.855V45.459ZM41.0536 42.227C41.0536 38.291 35.3256 39.539 35.3256 37.299C35.3256 36.387 35.9816 35.955 36.8616 35.987C37.8216 36.003 38.4136 36.579 38.4616 37.315H40.9256C40.7816 35.299 39.2136 34.131 36.9256 34.131C34.6216 34.131 32.9896 35.347 32.9896 37.363C32.9736 41.411 38.7336 39.955 38.7336 42.371C38.7336 43.171 38.1096 43.731 37.0536 43.731C36.0136 43.731 35.4216 43.139 35.3576 42.243H32.9576C32.9896 44.355 34.7816 45.571 37.1016 45.571C39.6456 45.571 41.0536 43.987 41.0536 42.227Z",
    fill: "#1E1E1E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6668 68C61.6668 74.9956 55.9958 80.6667 49.0002 80.6667C42.0046 80.6667 36.3335 74.9956 36.3335 68C36.3335 61.0044 42.0046 55.3333 49.0002 55.3333C55.9958 55.3333 61.6668 61.0044 61.6668 68Z",
    fill: "#5ECC61",
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6067 62.6875L47.0715 70.1417L43.9928 66.9357L41.917 69.0913L47.1239 74.4232L56.7338 64.8122L54.6067 62.6875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_13350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSuccessIcon);
export default __webpack_public_path__ + "static/media/PhoneSuccessIcon.908a8ce543c26e7e550045fb4aa94e58.svg";
export { ForwardRef as ReactComponent };